import React, { Component } from 'react';
import { Parallax } from "react-parallax";

export class OurStory extends Component {
    render() {
        return (
            <section id="OurStory">
                <Parallax blur={4} bgImage="../img/parallax-bg-1.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 500, width: 100 }} />
                    <div className="parallax-box">Our Beginnings</div>
                </Parallax>
                <div id="about-content" className="p-5 body-lt">
                    <p className="italic">
                        “Hel-lo, m-y nam-e is Sh-an-el. I a-m fif-teen y-ears o-l-d.”
                    </p>
                    <p>
                        This was the first time that I met Shanel, a shy but cheerful young girl who suffers from autism
                        spectrum disorders (ASD). Although ASD was a foreign condition, I was sure that Shanel had
                        suffered greatly because of this.
                    </p>
                    <p>
                        People with ASD usually suffer severe deficits in social interactions, repetitive behaviors, and
                        even delayed or disordered languages. It is an unfortunately common disease that currently affects
                        about 1% of all children, and sadly has no current cure. Through Shanel, I got to work with FCSN,
                        otherwise known as Friends of Children with Special Needs. Volunteering there, I realized how there
                        were a considerable number of children and adults who suffered from various types of psychological
                        disorders due to their uncontrollable circumstances. While we can't give them an immediate cure,
                        we can help them build bright futures. Together, we can give Shanel and her community a sense of
                        normalcy and integrate more diversity into our society.
                    </p>
                </div>
            </section>
        );
    }
}

export class WhatWePropose extends Component {
    render() {
        return (
            <section id="OurConcept">
                <Parallax blur={4} bgImage="../img/parallax-bg-2.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 600, width: 100 }} />
                    <div className="parallax-box">Our Concept</div>
                </Parallax>
                <div id="about-content" className="p-5 body-lt">
                    <p>
                        Our concept behind SpeNeeds is to create a web application which aims to assist individuals with special
                        needs and close relatives to find meaningful programs and social connections through live events.
                        The website itself contains a large database of events and programs tailored to the special needs community.
                        SpeNeeds will give recommendations for activities that families can consider, as well as include organizations
                        of potential interest to those who benefit from the website.
                    </p>
                    <p>
                        The database of events stems directly from registered organizations' participation and input to the website.
                        All of the registered organizations are verified to ensure a legitimate and pleasant experience for families.
                        Registered organizations can link their specific programs with details onto the event pages. Furthermore, selected
                        labels will be given based on the program’s interest to help users find and sort their activities of interest.
                        In addition to communal events, families can also seek compatible programs or tutors based on their children’s age,
                        personal interests, as well as behavioral and health statuses. For parents who wish to ask questions or communicate
                        with the staff of certain programs, a Q&#38;A section is available under each program's full description to further
                        advocate free communication and address any concerns or issues. We understand that there is no mold for your child,
                        and so you should have the ability to properly get verified details!
                    </p>
                </div>
            </section>
        );
    }
}